export default __webpack_public_path__ + "ba6a986dd28426ede258e3a266263275.png";